import { Spinner } from '@ami/react/core';
import PropTypes from 'prop-types';
import React from 'react';
import EffectiveLeadTimeLabel from '../../quotes/lead-times/EffectiveLeadTimeLabel';
import { QuoteProductDto } from '../../quotes/otherQuoteEntities';
import { QuoteProductConfiguration } from '../../quotes/quoteProductConfiguration';
import { LeadTimeComponentOutput } from '../../quotes/quoteProductLeadTimeService';
import LeadTimeComponent from './LeadTimeComponent';

const LeadTimesBanner = () => {
  return (
    <div className="alert alert-warning py-1 mt-1 w-100">
      <div className='d-flex align-items-center'>
        <div className='flex-grow-0 me-1'>
          <i className="fa fa-exclamation-circle text-danger" />
        </div>
        <div className='flex-grow-0'>
          Lead Time Overrides are not available when editing a quote.
        </div>
      </div>
    </div>
  );
};

export default class LeadTimeBreakdownComponent extends React.PureComponent {
  static propTypes = {
    quoteProduct: PropTypes.instanceOf(QuoteProductDto).isRequired,
    quoteProductConfiguration: PropTypes.instanceOf(QuoteProductConfiguration).isRequired,
    quoteId: PropTypes.string,
    isEditMode: PropTypes.bool,
    isOverrideMode: PropTypes.bool,
    showLeadTimeCalculationSpinner: PropTypes.bool,
    onLeadTimeOverridden: PropTypes.func,
    onLeadTimeRemoved: PropTypes.func
  };

  overrideLeadTime = (updatedItem, leadTime) => {
    this.props.onLeadTimeOverridden(updatedItem, leadTime);
    this.forceUpdate();
  };

  removeLeadTimeOverride = (removedItem, leadTime) => {
    this.props.onLeadTimeRemoved(removedItem, leadTime);
    this.forceUpdate();
  };

  render() {
    const { quoteProduct, quoteProductConfiguration, isEditMode, isOverrideMode, quoteId, showLeadTimeCalculationSpinner } = this.props;
    const leadTime = quoteProduct.leadTime;
    const totalLeadTimeInDays = quoteProduct.totalLeadTimeInDays ?? leadTime.totalLeadTimeInDays;
    const availableOn = quoteProduct.availableOn ?? leadTime.availableOn;

    let productName = quoteProduct.productGroupName;
    if (!productName && quoteProduct.productGroupId) {
      const product = quoteProductConfiguration.products.find((x) => x.id === quoteProduct.productId);
      productName = `${product.partNumber}`;
    }

    if (!leadTime || showLeadTimeCalculationSpinner) {
      return (
        <div className="container text-center">
          <h4 className="mt-5 mb-2">Loading</h4>
          <Spinner show={true} size="fa-5x" />
        </div>
      );
    }

    return (
      <div className="option-set-form">
        <div className="lead-time-details">
          {isEditMode && <LeadTimesBanner />}
          <LeadTimeComponent
            name={productName}
            leadTimeItem={new LeadTimeComponentOutput(leadTime?.product)}
            quoteProduct={quoteProduct}
            isOverrideMode={isOverrideMode}
            isNewQuote={!quoteId}
            onLeadTimeOverridden={this.overrideLeadTime}
            onLeadTimeRemoved={this.removeLeadTimeOverride}
            eligibleForFastTrack={leadTime.eligibleForFastTrack}
            isLuggingOnlyFastTrack={leadTime.isLuggingOnlyFastTrack}
          />

          <div className='hr-divider inverse mb-1 mt-1'>
            <h4 className='hr-divider-content hr-divider-heading'></h4>
          </div>
          {
            leadTime?.productOptions.map((productOption, idx) => {
              const optionSet = quoteProduct.productOptions.find((x) => x.productOptionId === productOption.correlationId);
              if (!optionSet)
                return ('');

              let optionName = optionSet.name;
              if (!optionName) {
                const quoteProductOptionFromConfiguration = quoteProductConfiguration.getProductOption(quoteProduct.productGroupId, optionSet.productOptionSetId, productOption.correlationId);
                optionName = quoteProductOptionFromConfiguration?.name;
              }
              return (
                <LeadTimeComponent
                  key={productOption.correlationId}
                  name={optionName}
                  leadTimeItem={new LeadTimeComponentOutput(productOption)}
                  quoteProduct={quoteProduct}
                  isOverrideMode={isOverrideMode}
                  isNewQuote={!quoteId}
                  onLeadTimeOverridden={this.overrideLeadTime}
                  onLeadTimeRemoved={this.removeLeadTimeOverride}
                  eligibleForFastTrack={leadTime.eligibleForFastTrack}
                  isLuggingOnlyFastTrack={leadTime.isLuggingOnlyFastTrack}
                />
              )
            })}
          <span className="me-2 text-lg">
            <strong>Effective Lead Time:</strong>
            <strong className='ms-1'>
              <EffectiveLeadTimeLabel leadTimeDays={totalLeadTimeInDays} showLeadTimeCalculationSpinner={false} showDaysAndWeeks={true} availableOn={availableOn} />
            </strong>
          </span>
        </div>
      </div>
    )
  }
}
